const getMapValues = (map, keyName = "id") => {
  const arr = [];
  map.forEach((value, key) => {
    if (key) arr.push({ [keyName]: key });
  });
  return arr;
};

// eslint-disable-next-line import/prefer-default-export
export { getMapValues };
